import { connect } from 'react-redux';
import { IDataStorage } from '../../core';
import { FxTranslate } from '../../core/translate';
import { Estados } from '../../services/operaciones';
import BoardComponent from './board.component';
import HeaderComponent from './header.component';

//import styles from "./index.module.scss";

export type IProps = {
  storage: IDataStorage;
  t: FxTranslate;

  /** datos completos a meter en el tablero (listado de op's) */
  data: ICardInfo[] | undefined;

  /** grupos a mostrar */
  grupos?: IGrupo[];
  
  /** cantidad de tarjetas ocultas x grupo */
  grupoCardsHidden?: { id: number, cards: number }[];

  /** devuelve los datos del grupo al que pertenece un elemento de "data" */
  getGrupo: (data:ICardInfo) => IGrupo;

  /** indica que un dato se puede mover a la siguiente lista de id de grupos */
  allowMoveIntoGroups: (data:number) => number[];
  
  /** Ocurre cuando se suelta una tarjeta */
  onDrop: (id?: string, destination?: IGrupo, sourceIndex?: number, destinationIndex?: number) => void;

  /** Ocurre cuando se hace click sobre la tarjeta para abrirla */
  onOpen: (data?: ICardInfo) => void;
  
  /** Ocurre cuando se pide ver mas tarjetas */
  onShowMoreCards: (idgrupo: number, cant: number) => void;

  /** pedido de recargar las tarjetas */
  onRefresh: () => void;

  /** abre una tarjeta */
  onOpenId: (codigo: string) => void;
}

function Board({ storage, t,
  data, 
  grupos, grupoCardsHidden, getGrupo, allowMoveIntoGroups,
  onDrop, onOpen, onShowMoreCards, onRefresh, onOpenId,
} : IProps) {
  return <>
    <div style={{ width: '100%', height: '100%', overflowX: 'auto' }}>
      <HeaderComponent t={t} onRefresh={onRefresh} onOpenId={onOpenId} />
      <BoardComponent 
        t={t} 
        data={data} 
        grupos={grupos} grupoCardsHidden={grupoCardsHidden} getGrupo={getGrupo} allowMoveIntoGroups={allowMoveIntoGroups} 
        onDrop={onDrop} onOpen={onOpen} onShowMoreCards={onShowMoreCards}
      />
    </div>
  </>;
}

export default connect((s:any) => ({ storage:s.main }))(Board);

export type IGrupo = {
  id: number;
  nombre: string;
}

export type ICardInfo = {
  tipo: 'CO' | 'OP';
  id: string;
  estado: Estados;
  lastupdate: string;

  coti_id: number;
  coti_codigo: string;
  cliente_id: number;
  cliente_nombre?: string;
  cliente_logo?: number;
  vendedor_id?: number;
  vendedor_nombre?: string;
  vendedor_avatar?: number;

  op_id?: number;
  op_codigo?: string;
  op_callme?: string;
  op_vendedor_id?: number;
  op_vendedor_nombre?: string;
  op_vendedor_avatar?: string;
  //op_pasajero_nombre?: string;

  fechadesde?: Date;
  diasCobertura?: number;
  proximaGestionFecha?: Date;
  email?: string;
  whatsapp?: string;
  callme?: string;
  mailme?: string;
  duplicidadPrincipal?: boolean;
  duplicidadPeriodo?: number;
}